/// The MyCorr mark on a 48×48 grid, drawn as a 4-wide stroke with bevel joins.
export const MYCORR_MARK = "M24 16V32L40 40V8L24 16ZM24 16L8 8V32";
